import
  {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
  } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { UserService } from 'src/app/core/user/user.service';
import { User } from 'src/app/core/model/user';
import { ApplicantService } from 'src/app/modules/apps/applicant/applicant.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit
{
  constructor(
    private cd: ChangeDetectorRef,
    private _translocoService: TranslocoService,
    // private _oneIdServcie: OneIdServcie,
    private _authService: AuthService,
    private _route: Router,
    public _uService: UserService,
    public applicantService: ApplicantService
  )
  {
    this.flagCodes = {
      uz: 'uz',
      ru: 'ru',
      en: 'en',
      kr: 'kr',
    };
  }

  sidebarOpened: boolean = false;
  availableLangs: any[] = [];
  activeLang: string = '';
  flagCodes: any;
  user: User;

  isAuth: boolean = false;

  ngOnInit(): void
  {
    this._authService.authenticated$.subscribe(isAuth =>
    {
      this.isAuth = isAuth;
      this.cd.detectChanges();

      if (isAuth)
      {
        this._uService.currentUser$.subscribe(user =>
        {
          this.user = user;
          this.user.avatar = localStorage.getItem('base64') ?? undefined;
          this.cd.detectChanges();
        });
      }
    });

    //debugger

    this.availableLangs = this._translocoService.getAvailableLangs();

    this._translocoService.langChanges$.subscribe(activeLang =>
    {
      this.activeLang = activeLang;
    });

    this.cd.detectChanges();
  }

  setActiveLang(lang: string): void
  {
    this._translocoService.setActiveLang(lang);
  }

  trackByFn(index: number, item: any): any
  {
    return item.id || index;
  }

  toggleSidebar()
  {
    this.sidebarOpened = !this.sidebarOpened;
    this.cd.detectChanges();
  }

  navigateToLoginPage()
  {
    this.isAuth
      ? this._route.navigate(['apps/applicant/profile'])
      : this._route.navigate(['oneid/gateway']);
  }
}
